import React, { Component } from "react";
import "./App.css";
// If true, it uses local functions - npm run serve in functions dir
// Tbg this should grab from an env
const debugging = false; // ********************************** //
const emojis = {
  hand: "💁🏻‍",
  shrug: "🤷🏻‍",
  facepalm: "🤦🏻",
  angry: "🙍🏻",
  no: "🙅🏻",
  pout: "🙎🏻",
  okay: "🙆🏻",
  haircut: "💇🏻",
  wave: "🙋🏻‍",
  massage: "💆🏻‍",
};
const functionsEndpoint = debugging
  ? "http://localhost:5000/remind-me-bitch/us-central1"
  : "https://us-central1-remind-me-bitch.cloudfunctions.net";
//   // Initialize Firebase
//   var config = {
//     apiKey: "AIzaSyCfOLe6IcIPKhiPYbvXkW1TDnTpxWYTs78",
//     authDomain: "remind-me-bitch.firebaseapp.com",
//     databaseURL: "https://remind-me-bitch.firebaseio.com",
//     projectId: "remind-me-bitch",
//     storageBucket: "remind-me-bitch.appspot.com",
//     messagingSenderId: "445603402031"
//   };
//   firebase.initializeApp(config);
// const datetimePlusTimezoneOffset = datetime => {
//   console.log("5pm, sheff:                 1529078379000");
//   console.log(
//     "datetimePlusTimezoneOffset ",
//     datetime + new Date().getTimezoneOffset() * 60000
//   );
//   return datetime + new Date().getTimezoneOffset() * 60000;
// };
const datetimeMinusTimezoneOffset = (datetime) => {
  console.log("5pm, sheff:                 1529078379000");
  console.log(
    "datetimeMinusTimezoneOffset",
    datetime - new Date().getTimezoneOffset() * 60000
  );
  return datetime - new Date().getTimezoneOffset() * 60000;
};
const unixTimeToIsoDatetime = (unixTime) => {
  return new Date(unixTime).toISOString().substring(0, 16);
};
const isoDatetimeToUnixTime = (isoDatetime) => {
  return new Date(isoDatetime).getTime();
};
let timer = 0;
setInterval(() => {
  timer += 100;
}, 100);
const pastAutofillTimeout = () => (timer >= 500 ? true : false);
class App extends Component {
  constructor(props) {
    super(props);
    let date = new Date();
    // "2018-05-17T12:25" (including timezone offset)
    this.state = {
      ready: true,
      emoji: emojis.hand,
      email: "",
      content: "",
      password: "",
      // Store datetime in database as unix time but NOT including timezone offset. Only show GMT offset and human readable for rendering purposes, then undo all of that every time the input is changed. SIGH
      //   datetime: new Date("2018-05-24T16:30").getTime()
      //   datetime: date.getTime()
      // Aaalso round to nearest 15 mins
      //   datetime: datetimeMinusTimezoneOffset(
      //     Math.ceil(date.getTime() / (1000 * 60 * 15)) * 1000 * 60 * 15
      //   )
      // Leave timezone offset stuff nearest to render
      datetime: Math.ceil(date.getTime() / (1000 * 60 * 15)) * 1000 * 60 * 15,
    };
    // Test functions api
    fetch(functionsEndpoint + "/helloWorld")
      .then((results) => {
        return results.json();
      })
      .then((results) => {
        console.log(results);
      });
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log(pastAutofillTimeout());
    if (pastAutofillTimeout()) {
      this.setState({
        emoji: emojis.pout,
      });
    }
  };
  handleChangeDatetime = (e) => {
    this.setState({
      //   [e.target.name]: datetimeMinusTimezoneOffset(
      //     isoDatetimeToUnixTime(e.target.value)
      //   )
      [e.target.name]: isoDatetimeToUnixTime(e.target.value),
    });
    // this.setState({
    //   [e.target.name]: isoDatetimeToUnixTime(e.target.value)
    // });
  };
  reset = () => {
    this.setState({
      ready: true,
      emoji: emojis.okay,
      content: "",
    });
  };
  handleSubmit(e) {
    e.preventDefault();
    let postState = this.state;
    // postState.datetime = datetimePlusTimezoneOffset(postState.datetime);
    this.setState({
      ready: false,
      emoji: emojis.massage,
    });
    console.log("postState.datetime          " + postState.datetime);
    fetch(functionsEndpoint + "/addReminder", {
      // https://stackoverflow.com/questions/29775797/fetch-post-json-data
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: "" + JSON.stringify(postState),
    })
      .then((results) => {
        return results.json();
      })
      .then((results) => {
        console.log(results);
        if (results.error) {
          this.setState({
            error: results.error,
            emoji: emojis.nom,
            ready: true,
          });
        } else {
          this.setState({
            message: results.message ? results.message : null,
          });
          this.reset();
        }
      });
  }
  render() {
    return (
      <main>
        <form
          onSubmit={this.handleSubmit.bind(this)}
          name="remind-me-bitch"
          id="remind-me-bitch"
        >
          <div className="login">
            <p>
              <input
                placeholder="Email"
                type="email"
                name="email"
                onChange={this.handleChange.bind(this)}
                required
              />
            </p>
            <p>
              <input
                placeholder="Password"
                type="password"
                name="password"
                onChange={this.handleChange.bind(this)}
                required
              />
              <small>Sorry, this is currently an invite-only service!</small>
            </p>
          </div>
          <p>
            <textarea
              name="content"
              onChange={this.handleChange.bind(this)}
              placeholder="Message"
              required
              maxLength="600"
              autofill="false"
            />
          </p>
          <p>
            <input
              type="datetime-local"
              name="datetime"
              step="900"
              value={unixTimeToIsoDatetime(
                datetimeMinusTimezoneOffset(this.state.datetime)
              )}
              //   value={unixTimeToIsoDatetime(this.state.datetime)}
              onChange={this.handleChangeDatetime.bind(this)}
              required
              autofill="false"
            />
          </p>
          <button type="submit" disabled={!this.state.ready}>
            Submit
          </button>
        </form>
        <aside>
          <div className="emoji">{this.state.emoji}</div>
          <div>{this.state.error}</div>
          <div>{this.state.message}</div>
        </aside>
      </main>
    );
  }
}
export default App;
